import { Navigate, useRoutes } from "react-router-dom";
import { RouteUrls } from "./Constants/RouteUrls";
import HomeScreen from "./Pages/HomeScreen";
import HeadScreen from "./Pages/Home/HeadScreen";
import NotFound from "./Pages/Home/HeadScreen/NotFound";
import Login from "./Pages/Login";
import OrderList from "./Pages/Home/HeadScreen/ListManagement/Orders";
import ListManagement from "./Pages/Home/HeadScreen/ListManagement";
import ChatList from "./Pages/Home/HeadScreen/ChatScreen/ChatList/index";
import ChatScreen from "./Pages/Home/HeadScreen/ChatScreen/index";
import ProtectedLayout from "./Layouts/ProtectedLayout";
import HomeLayout from "./Layouts/HomeLayout";
import Dashboard from "./Pages/Dashboard";
import Register from "./Pages/Registration/index";
import ProfessionalRegister from "Pages/Registration/Professional";
import CustomerRegister from "Pages/Registration/User";
import MainLayout from "Layouts/MainLayout";
import CaseCreation from "./Pages/Home/HeadScreen/CaseManagement/Creation/index";
import PaymentGateway from "Pages/Home/HeadScreen/CaseManagement/Payment";
import CaseManagement from "Pages/Home/HeadScreen/CaseManagement";
import PendingVerification from "Pages/Waiting";
import ForgotPassword from "Pages/Forgot/ForgotPassword";
import ResetPassword from "Pages/Forgot/ResetPassword";
import CorporateList from "Pages/AdminList/CorporateList";
import ProfessionalUserList from "Pages/AdminList/ProfessionalUserList";
import AssignProfessional from "Pages/AdminList/AssignProfessional";
import OrderHistory from "Pages/OrderHistory/OrderHistory";
import Profile from "Pages/Profile/index"
import UserProfileForm from "Pages/UserProfileForm/index"
import Hotline from "Pages/AdminList/Hotline";
import CaseDetails from "Pages/AdminList/CaseDetails";
import AdminUserManagement from "Pages/AdminList/AdminUserManagement";
import RewardDashboard from "Pages/Reward/reward";
import PaymentsHistory from "Pages/PaymentHistory/PaymentHistory";
import CaseDashboard from "Pages/CaseDashboard";
import AllUsers from "Pages/AdminList/AllUsers";
import PaymentProcess from "Pages/AdminList/PaymentProcess";
import NriRegister from "Pages/Registration/NRI";
import ProfessionalPaymentProcess from "Pages/AdminList/ProfessionalPaymentProcess";
import ProfessionalSelectionList from "Pages/AdminList/professionalUserListingByAdmin";
import SuperAdminApproval from "Pages/AdminList/superAdminPaymentAprove";

const Router = () => {
  const routes = useRoutes([
    // Public Routes with home layout i.e. pre login Header with menu and footer without sidebar.
    //If need to add new routes with pre login header and footer and without protection, Add in children
    //Public Routes
    { path: "/login", element: <Login /> },
    {
      path: RouteUrls.forgot,
      element: <ForgotPassword />,
    },
    {
      path: RouteUrls.ResetPassword,
      element: <ResetPassword />,
    },
    {
      path: "/register",
      element: <Register />,
      children: [
        { path: "", element: <Navigate to="/register/customer" replace /> },
        { path: RouteUrls.professional, element: <ProfessionalRegister /> },
        { path: RouteUrls.customer, element: <CustomerRegister /> },
        { path: RouteUrls.corporate, element: <CustomerRegister /> },
        { path: RouteUrls.NriSignup, element: <NriRegister /> },
      ],
    },
    {
      path: RouteUrls.PendingVerification,
      element: <PendingVerification />,
    },
    {
      element: <HomeLayout />,
      children: [{ path: "/", element: <HomeScreen /> }],
    },

    // Protected Routes
    {
      element: <ProtectedLayout />,
      children: [
        // Main layout with Sidebar and post login Header and footer with Protection
        // If need Main layout with protection Add routed in this children
        {
          element: <MainLayout />,
          children: [
            { path: RouteUrls.dashboard, element: <Dashboard /> },
            { path: RouteUrls.OrderHistory, element: <OrderHistory /> },
            { path: RouteUrls.profile, element: <Profile /> },
            { path: RouteUrls.userProfileForm, element: <UserProfileForm /> },
            {
              path: RouteUrls.case,
              element: <CaseManagement />,
              children: [
                {
                  path: "",
                  element: <Navigate to={RouteUrls.caseCreation} replace />,
                },
                {
                  path: RouteUrls.caseCreation,
                  children: [
                    {
                      path: "",
                      element: <CaseCreation />,
                    },
                    {
                      path: `:caseId/${RouteUrls.payment}`,
                      element: <PaymentGateway />,
                    },
                  ],
                },
              ],
            },
            {
              path: RouteUrls.chat,
              element: <ChatScreen />,
              children: [
                { path: "", element: <ChatList /> }, // default route: /chat
                { path: ":orderType", element: <ChatList /> }, // /chat/someOrderType
              ],
            },
            {
              path: RouteUrls.corporateList,
              element: <CorporateList />,
              // children: [{ path: "", element: <ProfessionalList /> }],
            },
            {
              path: RouteUrls.professionalUsers,
              element: <ProfessionalUserList />,
            },
            {
              path: `${RouteUrls.CaseDetails}/:caseId`,
              element: <CaseDetails />,
            },
            {
              path: RouteUrls.AssignProfessional,
              element: <AssignProfessional />,
            },
            {
              path: RouteUrls.Hotline,
              element: <Hotline />,
            },
             {
              path: RouteUrls.AdminUserManagement,
              element: <AdminUserManagement />,
            },
            {
              path: RouteUrls.RewardProgram,
              element: <RewardDashboard />,
            },
            {
              path: RouteUrls.PaymentHistory,
              element: <PaymentsHistory />,
            },
             {
              path: RouteUrls.CaseDashboard,
              element: <CaseDashboard />,
            },
            {
              path: RouteUrls.AllUsers,
              element: <AllUsers />,
            },
            {
              path: RouteUrls.AllUsers,
              element: <AllUsers />,
            },
             {
              path: RouteUrls.PaymentProcess,
              element: <PaymentProcess />,
            },
            {
              path: RouteUrls.professionalUserListing,
              element: <ProfessionalSelectionList />,
            },
            {
              path: `${RouteUrls.ProfessionalPaymentProcess}/entry/:profId`,
              element: <ProfessionalPaymentProcess />,
            },
             {
              path: RouteUrls.SuperAdminApproval,
              element: <SuperAdminApproval />,
            },
          ],
        },
      ],
    },

    // Fallback
    { path: "*", element: <Navigate to="/home.html" replace /> },
  ]);

  return routes;
};

export default Router;
